import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

const demoRows = [
  { product: 'Retro Sneaker', category: 'Shoes', price: '¥198', status: 'In stock' },
  { product: 'Oversized Hoodie', category: 'Hoodies', price: '¥149', status: 'In stock' },
  { product: 'Box Logo Tee', category: 'T-Shirts', price: '¥89', status: 'Checking' },
  { product: 'Cargo Pants', category: 'Pants', price: '¥159', status: 'In stock' },
  { product: 'Crossbody Bag', category: 'Bags', price: '¥129', status: 'Sold out' },
];

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <div className="mx-auto grid max-w-content grid-cols-1 items-center gap-10 px-4 md:px-6 py-12 md:py-20 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-sparkling-2-line text-sm" />
            {t('hero.eyebrow')}
          </span>
          <h1 className="mt-5 font-heading text-4xl font-bold leading-tight text-foreground-950 md:text-5xl">
            {t('hero.title')}
          </h1>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-foreground-600 md:text-lg">
            {t('hero.subtitle')}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors"
            >
              {t('hero.ctaPrimary')}
              <i className="ri-external-link-line text-sm" />
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-accent-600 transition-colors"
            >
              {t('hero.ctaSecondary')}
              <i className="ri-shopping-bag-3-line text-sm" />
            </a>
            <Link
              to="/articles/basetao-spreadsheet/"
              className="inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-md px-3 py-3 text-sm font-medium text-primary-700 hover:text-primary-800 transition-colors"
            >
              {t('hero.ctaGuide')}
              <i className="ri-arrow-right-line text-sm" />
            </Link>
          </div>
        </div>

        <div className="relative">
          <div className="rounded-lg border border-background-200/70 bg-background-50 p-4 md:p-5">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="flex h-2.5 w-2.5 rounded-full bg-accent-400" />
                <span className="flex h-2.5 w-2.5 rounded-full bg-primary-400" />
                <span className="flex h-2.5 w-2.5 rounded-full bg-secondary-400" />
              </div>
              <span className="text-xs font-medium text-foreground-500">finds-sheet.csv</span>
            </div>

            <div className="mt-4 overflow-x-auto">
              <table className="w-full min-w-[420px] text-left text-sm">
                <thead>
                  <tr className="border-b border-background-200/70 text-xs text-foreground-500">
                    <th className="py-2 pr-3 font-medium">Product</th>
                    <th className="py-2 pr-3 font-medium">Category</th>
                    <th className="py-2 pr-3 font-medium">Price</th>
                    <th className="py-2 font-medium">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {demoRows.map((row) => (
                    <tr key={row.product} className="border-b border-background-100">
                      <td className="py-2.5 pr-3 font-medium text-foreground-800">{row.product}</td>
                      <td className="py-2.5 pr-3 text-foreground-600">{row.category}</td>
                      <td className="py-2.5 pr-3 text-foreground-600">{row.price}</td>
                      <td className="py-2.5">
                        <span
                          className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${
                            row.status === 'In stock'
                              ? 'bg-primary-100 text-primary-900'
                              : row.status === 'Sold out'
                                ? 'bg-accent-100 text-accent-900'
                                : 'bg-secondary-100 text-secondary-900'
                          }`}
                        >
                          {row.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <p className="mt-3 text-xs text-foreground-400">{t('hero.demoLabel')}</p>
          </div>
        </div>
      </div>
    </section>
  );
}